module.exports = __webpack_public_path__ + "assets/img/soldiers_3.8bd025d2.png";